'use client'

import { useTranslations } from 'next-intl'

import JoinArenaArrow from '@/assets/icons/join-arena-arrow.svg'
import { URLS } from '@/configs/urls'
import { getClubDashboardHref } from '@/features/clubs/getClubDashboardHref'
import { useClubMe } from '@/hooks/useClubMe'
import { useForClubsAudience } from '@/hooks/useForClubsAudience'
import { Link } from '@/i18n/routing'
import { useAuth } from '@/providers/AuthProvider'

import S from './ForClubsHero.module.scss'

const ForClubsHeroIntro = () => {
  const t = useTranslations('forClubsPage.hero')
  const tCta = useTranslations('forClubsPage.members.cta')
  const { openAuthModal } = useAuth()
  const { showClubOwnerExperience, isGuest } = useForClubsAudience()
  const { data: clubData } = useClubMe({ enabled: showClubOwnerExperience })
  const dashboardHref = getClubDashboardHref(clubData)

  return (
    <div className={S.content}>
      <p className={S.eyebrow}>{t('eyebrow')}</p>
      <h1 className={S.headline}>
        <span className={S.headlineWhite}>{t('headlineWhite')}</span>
        <span className={S.headlineAccent}>{t('headlineAccent')}</span>
      </h1>
      <p className={S.bodyLine}>{t('bodyLine')}</p>
      <div className={S.ctaRow}>
        {showClubOwnerExperience ? (
          <Link href={dashboardHref} className={S.joinCta}>
            <span className={S.joinCtaText}>{tCta('viewDashboard')}</span>
            <JoinArenaArrow className={S.joinCtaArrow} aria-hidden />
          </Link>
        ) : (
          isGuest && (
            <button
              type="button"
              className={S.joinCta}
              onClick={() =>
                openAuthModal('emailSignupEntityChoose', 'landing')
              }
            >
              <span className={S.joinCtaText}>{t('joinArena')}</span>
              <JoinArenaArrow className={S.joinCtaArrow} aria-hidden />
            </button>
          )
        )}
        <a href={URLS.PLATFORM_BLOCK} className={S.howItWorksLink}>
          <span className={S.howItWorksText}>{t('howItWorks')}</span>
        </a>
      </div>
    </div>
  )
}

export default ForClubsHeroIntro
